<template>
  <div class="bug-report">
    <span class="text">משהו נראה לא נכון?</span>
    <span class="link" v-on:click="action()">דווחו כאן על תקלה</span>
  </div>
</template>

<script>
export default {
  name: 'CardBugReport',
  props: {
    action: Function,
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';

  .bug-report {
    margin-top: 4px;
    font-size: 14px;
    text-align: center;
    font-family: SimplerProBold;

    .text {
      color: $riseup_gray_2;
    }

    .link {
      color: $riseup_blue;
      text-decoration: underline;
      cursor: pointer;
    }
  }
</style>
